import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar, FiShield, FiAward, FiUsers, FiMapPin } = FiIcons;

const TrustSignals = () => {
  const trustMetrics = [
    { icon: FiStar, value: "4.8/5", label: "Google Rating", subtext: "From 990 Reviews" },
    { icon: FiUsers, value: "10k+", label: "Vehicles Sold", subtext: "In Nova Scotia" },
    { icon: FiMapPin, value: "Local", label: "Dartmouth Based", subtext: "550 Windmill Rd" },
    { icon: FiShield, value: "Certified", label: "Quality Checks", subtext: "150-Point Inspection" }
  ];

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="space-y-6">
      <div className="bg-gray-800 rounded-xl p-6 border border-gray-700">
        <h3 className="text-xl font-bold text-white mb-6 flex items-center">
          <SafeIcon icon={FiAward} className="w-5 h-5 mr-2 text-blue-500" />
          Why Choose Carson Exports?
        </h3>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {trustMetrics.map((metric, index) => (
            <div key={index} className="text-center p-4 bg-gray-900/50 rounded-xl border border-gray-700/50">
              <div className="w-12 h-12 bg-blue-600/10 rounded-full flex items-center justify-center mx-auto mb-3">
                <SafeIcon icon={metric.icon} className="w-6 h-6 text-blue-500" />
              </div>
              <div className="text-xl font-bold text-white">{metric.value}</div>
              <div className="text-gray-300 font-medium text-sm">{metric.label}</div>
              <div className="text-gray-500 text-[10px] uppercase tracking-wider">{metric.subtext}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-blue-600/10 border border-blue-500/30 rounded-xl p-4 text-center">
        <p className="text-blue-400 text-sm font-semibold">
          ⭐ Top Rated Used Car Dealer in Dartmouth with 990+ Happy Customers
        </p>
      </div>
    </motion.div>
  );
};

export default TrustSignals;